<template>
    <div>
        <test-template :testName="testName" :testId="testId" :test="test">
            <template #questions>
                <question-card :question="cQ" v-model="questionResult" :progress="$store.state.tests.currentSlide" :questionnaireLength="$store.state.tests.test.length"  @answerQuestion="() => { $store.commit('tests/incrementSlide') }" @submitQuestionnaire="saveTestResults"></question-card>
            </template>
            <template #results>
                <div class="first">
                    <h3 class="subtitle-card text-center">{{ $t('tests.testResults') }} - {{ testName.toUpperCase() }}</h3>
                    <column-chart :lastYearResults="$store.state.tests.previousTestResults.slice(-12)" :testName="testName" class="justify-content-center" percentages></column-chart>
                </div>
                <div class="second">
                    <b-card class="neu-card mean-result col-lg-7">
                        <h3 class="subtitle-card"> {{ testName }}</h3>
                        <b-row class="h-100" align-h="center">
                            <b-row>
                                <h5 class="p-white" :style="`color: ${resultInfo.color}`" v-html="resultInfo.tag.toUpperCase()"></h5>
                            </b-row>
                            <b-row align-h="center">
                                <gauge-chart :labels="[testName]" :result="DBResults.percentage" opposedColours :customColour="resultInfo.color"></gauge-chart>
                            </b-row>
                        </b-row>
                    </b-card>
                </div>
            </template>
        </test-template>
    </div>
</template>

<script>
import TestTemplate from './TestTemplate.vue'
import { BCard } from 'bootstrap-vue'
import { TEST_ANXIETY_BECK } from '@/constants/patientServices'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'

export default {
    mixins: [selfEvaluationTestMixin],
    components: {
        'test-template': TestTemplate,
        BCard,
        'column-chart': () => import('@/components/charts/ColumnChart.vue'),
        'loading-anim': () => import('@/components/utils/LoadingAnim'),
        'gauge-chart': () => import('@/components/charts/GaugeChart.vue')
    },
    data () {
        const values = [
            {value: 0, text: this.$t('tests.answers.no')},
            {value: 1, text: this.$t('tests.answers.slightly')},
            {value: 2, text: this.$t('tests.answers.moderately')},
            {value: 3, text: this.$t('tests.answers.severely')}
        ]

        return {
            test: [],
            values: values,
            testId: TEST_ANXIETY_BECK,
            testName: this.$t('tests.anxiety-beck.title')
        }
    },
    created () {
        this.createQuestions()
    },
    methods: {
        createQuestions () {
            const totalQuestions = 21
            for (let i = 1; i <= totalQuestions; i++) {
                this.test.push({
                    id: `q${i}`,
                    question: this.$t(`tests.anxiety-beck.questions.q${i}`),
                    answer: this.values,
                    result: null
                })
            }
        },
        saveTestResults () {
            const result = this.test.map(x => x.result).reduce((a, b) => a + b, 0)
            this.save(null, result, this.percentResult(result, 63))
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/AnxietyBeckTest.vue